import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTWCL_Please_verify_your_identity_wi_ELL_1,
  TXTWCL_The_account_you_are_using_is_u_ELL,
  TXTWCL_This_means_your_withdrawals_wi_ELL,
  TXTWCL_Your_details_have_been_savedX
} from './Base.messages.json';

const Base: React.FC = () => (
  <Typography component="div">
    <Translation {...TXTWCL_Your_details_have_been_savedX} />{' '}
    <Translation {...TXTWCL_The_account_you_are_using_is_u_ELL} />{' '}
    <Translation {...TXTWCL_This_means_your_withdrawals_wi_ELL} />
    <Translation tagName="p" {...TXTWCL_Please_verify_your_identity_wi_ELL_1} />
  </Typography>
);

export default Base;
